// extracted by mini-css-extract-plugin
module.exports = {"Categories":"Categories_Categories__3LNF-"};